import { useMutation, useQueryClient } from "@tanstack/react-query";

import { getGaragesQueryOptions } from "./get-garages";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export const deleteGarage = ({ garageId }: { garageId: string }) => {
  return api.delete(`/carburate/garages/${garageId}/`);
};

type UseDeleteGarageOptions = {
  mutationConfig?: MutationConfig<typeof deleteGarage>;
};

export const useDeleteGarage = ({ mutationConfig }: UseDeleteGarageOptions = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: getGaragesQueryOptions().queryKey,
      });
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: deleteGarage,
  });
};
